import { z } from "zod";
import { RichTextSchema } from "../RichText";
import { MediaSchema } from "../Media";
export const CharacterMoveCostSchema = z.object({
    value: z.number(),
    maximumValue: z.number(),
});
export const CharacterMoveSchema = z.object({
    id: z.string(),
    label: z.string().optional(),
    description: RichTextSchema,
    input: RichTextSchema,
    media: MediaSchema,
    cost: CharacterMoveCostSchema.optional(),
});
//# sourceMappingURL=index.js.map